<template>
  <v-data-table
    :headers="headers"
    :items="relatoriosTabela"
    :search="opcoes.pesquisa"
    :sort-by="opcoes.ordenarPor"
    :sort-desc="opcoes.decrescente"
    class="elevation-0"
  >
    <!-- ordenar por e pesquisar -->
    <template v-slot:top>
      <v-row class="mb-2">
        <v-toolbar flat>
          <v-toolbar-title>
            <h2 class="title primary--text text--darken-1 text-no-wrap">
              {{ titulo }}
            </h2>
          </v-toolbar-title>
        </v-toolbar>
      </v-row>

      <!-- ordenar por -->
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <app-sort v-model="opcoes" />
        </v-col>

        <v-col
          cols="0"
          md="4"
        />

        <!-- pesquisar -->
        <v-col
          cols="12"
          md="4"
        >
          <app-search v-model="opcoes" />
        </v-col>
      </v-row>
    </template>

    <template v-slot:[`item.numero`]="{ index }">
      {{ index + 1 }}
    </template>
  </v-data-table>
</template>

<script>
import _ from 'lodash';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';

export default {
  name: 'TabelaDispensados',

  components: { AppSort, AppSearch },

  props: {
    relatorios: {
      type: Array,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'Nº',
          value: 'numero',
          width: '2%',
          sortable: false,
        },
        {
          text: 'SERVIDOR',
          value: 'usuario.nome',
          width: '30%',
          sortable: false,
        },
        {
          text: 'UNIDADE',
          value: 'unidade.sigla',
          width: '15%',
          align: 'center',
        },
        {
          text: 'CATEGORIA',
          value: 'usuario.categoria',
          width: '15%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'MOTIVO',
          value: 'motivoDispensado',
          width: '40%',
          sortable: false,
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'usuario.nome',
        selecionado: { id: 'usuario.nome', descricao: 'Servidor' },
        lista: [
          { id: 'usuario.nome', descricao: 'Servidor' },
          { id: 'unidade.sigla', descricao: 'Sigla da Unidade' },
          { id: 'usuario.categoria', descricao: 'Categoria' },
          { id: 'motivoDispensado', descricao: 'Motivo da Dispensa' },
        ],
      },
    };
  },

  computed: {
    relatoriosTabela() {
      return _.flatMap(this.relatorios, (r) => r.servidores
        .filter((s) => s.foiDispensado)
        .map((s) => ({
          ...s,
          ...r,
        })));
    },
  },
};
</script>
